// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3SGDa","text":"SelectPayment_text__3Slgf","title":"SelectPayment_title__dfEoY","btn":"SelectPayment_btn__3mrCl"};